import { PimProductTypeSystemKey } from "../../../clients/graphqlTypes.js";

export const PRODUCT_PREFERENCES_PATH = "/products/preferences";

export const PRODUCT_TYPE_SYSTEM_KEYS: readonly PimProductTypeSystemKey[] = [
  "ETIM6",
  "ETIM7",
  "ETIM8",
  "ETIM9",
  "ETIM10",
];

export const PRODUCT_TYPE_SYSTEM_SEARCH_PARAM = "productTypeSystem";

/**
 * The product type system travels in the URL unless it is the known current one. A
 * preference stored under a superseded system is addressable by `(system, key)` alone, while
 * for the current system the key on its own keeps the link readable.
 */
export function productTypePreferencesPath(
  productType: { productTypeKey: string; productTypeSystemKey: string },
  currentProductTypeSystemKey: string | null
): string {
  const path = `${PRODUCT_PREFERENCES_PATH}/${encodeURIComponent(productType.productTypeKey)}`;
  // Omitted only against a *known* current system: while it is unknown the bare key would be
  // ambiguous, and a key present under two systems would reopen the wrong one.
  return currentProductTypeSystemKey !== null &&
    productType.productTypeSystemKey === currentProductTypeSystemKey
    ? path
    : `${path}?${PRODUCT_TYPE_SYSTEM_SEARCH_PARAM}=${encodeURIComponent(productType.productTypeSystemKey)}`;
}

export function parseProductTypeSystemKey(
  value: string | null
): PimProductTypeSystemKey | null {
  return PRODUCT_TYPE_SYSTEM_KEYS.find(key => key === value) ?? null;
}
